import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as vinWonderActions from './../../../../actions/vinWonderAction';
import VinWonder from './VinWonder';

const mapStateToProps = state => {
    return {
        vinWondersState: state.vinWonderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListVinWonder: (filters) => dispatch(vinWonderActions.dataVinWonderAction(filters)),
        onDeleteVinWonder: (id) => dispatch(vinWonderActions.deleteVinWonderAction(id)),
        getVinWonderSites: () => dispatch(vinWonderActions.vinWonderSitesAction()),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonder));
